import React from "react";
import TimeEntriesPanel from "../components/TimeEntriesPanel";

const TimeEntriesScreen = ({
  dataLoading = false,
  dataLoadingLabel = "Refreshing timesheet",
  holidays = [],
  isTimesheetLocked,
  monthTimesheet,
  onAction,
  onRefreshTimesheet,
  onSubmitTime,
  onSubmitTimesheetApproval,
  onTimeCellEdit,
  onTimesheetCellToggle,
  onTimesheetDateSelect,
  onTimesheetMonthChange,
  selectedTimesheetCellIds,
  selectedTimesheetCellCount,
  selectedTimesheetDate,
  selectedTimesheetMonth,
  selectedTimesheetMonthId,
  projectOptions = [],
  taskOptions = [],
  timesheetMonths,
  timeLoading = false,
  timeLoadingLabel = "Saving timesheet",
  timesheetLockMessage,
  totalHours,
}) => {
  const loading = dataLoading || timeLoading;
  return (
    <section className="new-hrm-screen new-hrm-time-screen">
      <TimeEntriesPanel
        fullScreen
        holidays={holidays}
        isTimesheetLocked={isTimesheetLocked}
        loading={loading}
        loadingLabel={timeLoading ? timeLoadingLabel : dataLoadingLabel}
        monthTimesheet={monthTimesheet}
        onAction={onAction}
        onRefreshTimesheet={onRefreshTimesheet}
        onSubmitTime={onSubmitTime}
        onSubmitTimesheetApproval={onSubmitTimesheetApproval}
        onTimeCellEdit={onTimeCellEdit}
        onTimesheetCellToggle={onTimesheetCellToggle}
        onTimesheetDateSelect={onTimesheetDateSelect}
        onTimesheetMonthChange={onTimesheetMonthChange}
        selectedTimesheetCellIds={selectedTimesheetCellIds}
        selectedTimesheetCellCount={selectedTimesheetCellCount}
        selectedTimesheetDate={selectedTimesheetDate}
        selectedTimesheetMonth={selectedTimesheetMonth}
        selectedTimesheetMonthId={selectedTimesheetMonthId}
        projectOptions={projectOptions}
        taskOptions={taskOptions}
        timesheetMonths={timesheetMonths}
        timesheetLockMessage={timesheetLockMessage}
        totalHours={totalHours}
      />
    </section>
  );
};

export default TimeEntriesScreen;
